var _style, _defs, _path, _path2, _rect, _rect2, _path3, _path4, _rect3, _rect4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreExcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000107549860767936519900000010661331466254672275_);}\n\t.st1{fill:#169154;}\n\t.st2{fill:#18482A;}\n\t.st3{fill:#0C8045;}\n\t.st4{fill:#17472A;}\n\t.st5{fill:#29C27F;}\n\t.st6{fill:#27663F;}\n\t.st7{fill:#19AC65;}\n\t.st8{fill:#129652;}\n\t.st9{fill:#0C7238;}\n\t.st10{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    transform: "translate(286.278 645)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -271.33,
    y: -626.54,
    width: 70.1,
    height: 63.09
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052825607786481921220000015146600096042375822_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16-2",
    style: {
      clipPath: "url(#SVGID_00000052825607786481921220000015146600096042375822_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    className: "st1",
    d: "M-227.52-626.54h-23.23c-1.69,0-3.06,1.37-3.06,3.06v12.72h26.29V-626.54z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    className: "st2",
    d: "M-253.8-579.13v12.62c0,1.69,1.37,3.06,3.05,3.06h23.23v-15.68H-253.8z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    x: -253.8,
    y: -610.77,
    className: "st3",
    width: 26.29,
    height: 15.78
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    x: -253.8,
    y: -594.99,
    className: "st4",
    width: 26.29,
    height: 15.86
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    className: "st5",
    d: "M-204.29-626.54h-23.23v15.78h26.29v-12.72C-201.23-625.17-202.6-626.54-204.29-626.54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    className: "st6",
    d: "M-227.52-579.13v15.68h23.23c1.69,0,3.05-1.37,3.05-3.05v-12.62L-227.52-579.13L-227.52-579.13 z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    x: -227.52,
    y: -610.77,
    className: "st7",
    width: 26.29,
    height: 15.78
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    x: -227.52,
    y: -594.99,
    className: "st8",
    width: 26.29,
    height: 15.86
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    className: "st9",
    d: "M-239.22-577.48h-29.16c-1.63,0-2.95-1.32-2.95-2.95v-29.16c0-1.63,1.32-2.95,2.95-2.95h29.16 c1.63,0,2.95,1.32,2.95,2.95v29.16C-236.28-578.8-237.6-577.48-239.22-577.48"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    className: "st10",
    d: "M-261.15-603.76h4.18l3.39,6.58l3.58-6.58h3.91l-5.38,8.76l5.51,8.76h-4.12l-3.7-6.89 l-3.68,6.89h-4.18l5.6-8.79L-261.15-603.76z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreExcel);
export default __webpack_public_path__ + "static/media/store-excel.6ecc7fdb4ee5d07b4b251f5bec03ed22.svg";
export { ForwardRef as ReactComponent };